"use strict";

angular.module("customer")
.component("customDiscountedPrice", {
    bindings: {
        catalogEntry: "=",
        catalogEntryVariant: "=?",
        vendor: "=",
        orderedQuantity: "=?",
        discountedQuantity: "=",
        discountedTotalMeasure: "=",
        customDiscountedPrice: "="
    },
    templateUrl: require("./custom-discounted-price.component.html"),
    controller: function($scope, CartItemService, StocksService) {
        var _this = this;
        var initialValue = this.customDiscountedPrice;
        var newValue = initialValue;

        this.$onInit = function() {
            if (_this.orderedQuantity === undefined) {
                _this.orderedQuantity = 0;
            }
        };

        this.getLengthClass = function() {
            return StocksService.getLengthClass(this.customDiscountedPrice);
        };

        this.getBasePrice = function() {
            var price = this.catalogEntry.price;
            if (this.catalogEntry.discount) {
                price = this.catalogEntry.discount_result.discounted_price;
            }
            if (this.catalogEntry.product.is_variable_measure) {
                price = this.catalogEntry.price_per_unit_of_measure;
            }
            return price;
        };

        this.getDiscountedAmount = function() {
            return -(this.getBasePrice() - this.customDiscountedPrice);
        };

        this.getDiscountedPercent = function() {
            return this.getDiscountedAmount() * 100 / this.getBasePrice();
        };

        this.isDisabled = function() {
            return StocksService.isOutOfStock(this.catalogEntry) && parseFloat(this.discountedQuantity) === 0;
        };

        this.isValueChanged = function() {
            return initialValue !== this.customDiscountedPrice;
        };

        this.saveCustomDiscountedPrice = function() {
            if (this.customDiscountedPrice !== newValue) {
                newValue = this.customDiscountedPrice;
                CartItemService.saveDiscountedQuantity(
                    this.catalogEntry, this.catalogEntryVariant, this.discountedQuantity, this.vendor, this.customDiscountedPrice
                ).then(function onSuccess() {
                    $scope.$emit("updateCart");
                });
            }
        };

        this.autoSelect = function($event) {
            $event.stopPropagation();
            return $event.target.select();
        };

        this.onBlur = function() {
            this.saveCustomDiscountedPrice();
        };

        this.getErrorClass = function() {
            var isQuantityValid = CartItemService.isCartItemQuantityValid(
                this.catalogEntry.quantity_min,
                this.catalogEntry.quantity_max,
                this.discountedQuantity
            );
            var totalQuantity = parseFloat(this.orderedQuantity);
            if (typeof this.discountedQuantity !== 'undefined') {
                totalQuantity += parseFloat(this.discountedQuantity);
            }
            var isInventoryQuantityValid = CartItemService.isProductInventoryQuantityValid(
                this.catalogEntry.inventory_quantity,
                totalQuantity
            );
            var isProductMultiplierValid = CartItemService.isProductMultiplierValid(
                this.catalogEntry.packaging_quantity,
                this.discountedQuantity
            );
            var isOrderedWithQuantityOfMeasureValid = CartItemService.isDiscountedWithQuantityOfMeasureValid(
                this.catalogEntry,
                this.vendor,
                this.discountedQuantity,
                this.discountedTotalMeasure
            );

            return {
                'quantity-error': (!isQuantityValid || !isInventoryQuantityValid || !isProductMultiplierValid || !isOrderedWithQuantityOfMeasureValid) && !this.isDisabled(),
                'value-changed': this.isValueChanged(),
                'value-unchanged': !this.isValueChanged(),
                'disabled': this.isDisabled()
            }
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/custom-discounted-price/custom-discounted-price.component.js
// module id = 809
// module chunks = 0